// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_sidebarLink__Z3h9t {
  font-family: "Nunito", sans-serif;
  margin-inline: 10px;
  padding: 0.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}
.style_sidebarLink__Z3h9t:hover {
  background: rgba(41, 121, 255, 0.1);
}
.style_activeLink__uV8mt {
  font-family: "Nunito", sans-serif;
  margin-inline: 10px;
  background: #4154f1;
  color: #fff;
  padding: 0.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
}
.style_boxLink__emsNG {
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.style_iconBox__ge-mL {
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  margin-right: 10px;
}
.style_heraderDash__9GMFF {
  display: flex;
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  padding-bottom: 0.9rem;
}
.style_navDash__zGc50 {
  display: flex;
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
}

.style_buttonUpload__NADcP {
  display: flex;
  justify-content: center;
  font-family: "Nunito", sans-serif;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid rgb(209, 213, 219);
  border-radius: 0.5rem;
  box-sizing: border-box;
  color: #111827;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  text-align: center;
  -webkit-text-decoration: none #d1d5db solid;
          text-decoration: none #d1d5db solid;
  text-decoration-thickness: auto;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.style_buttonUpload__NADcP:hover {
  background-color: rgb(249, 250, 251);
}

.style_buttonUpload__NADcP:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.style_buttonUpload__NADcP:focus-visible {
  box-shadow: none;
}

.style_titleHome__JvD\\+- {
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  font-size: 20px;
  border: none;
  outline: none;
}

.style_saveForLater__TnFwg {
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  margin-right: 10px;
  background-color: rgba(41, 121, 255, 0.1);
  border-radius: 12px;
  border: none;
  padding: 10px 20px;
  color: black;
}

.style_cancel__b\\+v9w {
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  background: rgba(176, 11, 11, 0.8);
  color: #fff;
  border-radius: 12px;
  border: none;
  padding: 8px 20px;
}

.style_closeDiv__nznkP {
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  position: fixed;
  bottom: 50%;
  z-index: 1201;
  border-radius: 22px;
  cursor: pointer;
  color: #4154f1;
  transition: 100ms ease-in-out;
}
.style_centerText__3Azhg {
  text-align: center;
  font-weight: 700;
  font-family: "Nunito", sans-serif;
}

.style_subText__PE08k{
  font-size: 12px;
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  text-align: center;
  color: rgb(71, 107, 71);
  margin-top: 0.3rem;
}

.style_likeBtn__fUzL-{
  border: none;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  color: #4154f1;
  padding: 10px;
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/style.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,2CAAmC;UAAnC,mCAAmC;EACnC,+BAA+B;EAC/B,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;0CACwC;EACxC,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uFAAuF;EACvF,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".sidebarLink {\n  font-family: \"Nunito\", sans-serif;\n  margin-inline: 10px;\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n}\n.sidebarLink:hover {\n  background: rgba(41, 121, 255, 0.1);\n}\n.activeLink {\n  font-family: \"Nunito\", sans-serif;\n  margin-inline: 10px;\n  background: #4154f1;\n  color: #fff;\n  padding: 0.5rem;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n}\n.boxLink {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n}\n.iconBox {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  margin-right: 10px;\n}\n.heraderDash {\n  display: flex;\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  justify-content: center;\n  align-items: center;\n  padding: 0.5rem;\n  padding-bottom: 0.9rem;\n}\n.navDash {\n  display: flex;\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  width: 100%;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.buttonUpload {\n  display: flex;\n  justify-content: center;\n  font-family: \"Nunito\", sans-serif;\n  align-items: center;\n  background-color: #ffffff;\n  border: 1px solid rgb(209, 213, 219);\n  border-radius: 0.5rem;\n  box-sizing: border-box;\n  color: #111827;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.25rem;\n  text-align: center;\n  text-decoration: none #d1d5db solid;\n  text-decoration-thickness: auto;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n}\n\n.buttonUpload:hover {\n  background-color: rgb(249, 250, 251);\n}\n\n.buttonUpload:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.buttonUpload:focus-visible {\n  box-shadow: none;\n}\n\n.titleHome {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  border: none;\n  outline: none;\n}\n\n.saveForLater {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  margin-right: 10px;\n  background-color: rgba(41, 121, 255, 0.1);\n  border-radius: 12px;\n  border: none;\n  padding: 10px 20px;\n  color: black;\n}\n\n.cancel {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  background: rgba(176, 11, 11, 0.8);\n  color: #fff;\n  border-radius: 12px;\n  border: none;\n  padding: 8px 20px;\n}\n\n.closeDiv {\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  background-color: #f5f5f5;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  position: fixed;\n  bottom: 50%;\n  z-index: 1201;\n  border-radius: 22px;\n  cursor: pointer;\n  color: #4154f1;\n  transition: 100ms ease-in-out;\n}\n.centerText {\n  text-align: center;\n  font-weight: 700;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.subText{\n  font-size: 12px;\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 700;\n  text-align: center;\n  color: rgb(71, 107, 71);\n  margin-top: 0.3rem;\n}\n\n.likeBtn{\n  border: none;\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  color: #4154f1;\n  padding: 10px;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarLink": `style_sidebarLink__Z3h9t`,
	"activeLink": `style_activeLink__uV8mt`,
	"boxLink": `style_boxLink__emsNG`,
	"iconBox": `style_iconBox__ge-mL`,
	"heraderDash": `style_heraderDash__9GMFF`,
	"navDash": `style_navDash__zGc50`,
	"buttonUpload": `style_buttonUpload__NADcP`,
	"titleHome": `style_titleHome__JvD+-`,
	"saveForLater": `style_saveForLater__TnFwg`,
	"cancel": `style_cancel__b+v9w`,
	"closeDiv": `style_closeDiv__nznkP`,
	"centerText": `style_centerText__3Azhg`,
	"subText": `style_subText__PE08k`,
	"likeBtn": `style_likeBtn__fUzL-`
};
export default ___CSS_LOADER_EXPORT___;
